"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_1 = require("react-router");
var withStyles_1 = require("@material-ui/styles/withStyles");
var CurrentUser_1 = require("src/CurrentUser");
var ErrorBoundary_1 = require("src/ErrorBoundary");
var Login_1 = require("src/Login");
var ConnectedPaymentForm_1 = require("./ConnectedPaymentForm");
var styles_1 = require("./styles");
var CheckoutPage = /** @class */ (function (_super) {
    __extends(CheckoutPage, _super);
    function CheckoutPage(props) {
        var _this = _super.call(this, props) || this;
        _this.onPaymentComplete = function () {
            _this.props.history.push('/library');
        };
        _this.redirectForLogin = function (props) {
            var currentUser = props.currentUser;
            if (currentUser.loading === false && currentUser.loggedInUser === null) {
                Login_1.setRedirectAfterAuth('/cart');
                props.history.push('/login');
                props.displayMessage('You must log in or sign in order to complete you purchase', 'info');
                return null;
            }
        };
        _this.redirectForLogin(props);
        return _this;
    }
    CheckoutPage.prototype.render = function () {
        this.redirectForLogin(this.props);
        var currentUser = this.props.currentUser;
        if (currentUser.loading === false && currentUser.loggedInUser === null) {
            return null;
        }
        return React.createElement(ConnectedPaymentForm_1.default, { onPaymentComplete: this.onPaymentComplete });
    };
    return CheckoutPage;
}(React.Component));
var DecoratedCheckoutPage = ErrorBoundary_1.withDisplayMessage(CurrentUser_1.withCurrentUser(CheckoutPage));
exports.default = withStyles_1.default(styles_1.default)(react_router_1.withRouter(DecoratedCheckoutPage));
